import { FC } from "react"

const ModalBody: FC = ({ children }) => {
  return <main className="modal-body">{children}</main>
}

export default ModalBody
